import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'angular2-cookie';
import { EmpresasService } from 'src/app/services/empresas/empresas.service';
import { LoginService } from 'src/app/services/login/login.service';
declare var $: any;
@Component({
  selector: 'app-empresas',
  templateUrl: './empresas.component.html',
  styleUrls: ['./empresas.component.css'],
})
export class EmpresasComponent implements OnInit {
  empresas = [];

  empresasList = [];

  // * ids Local Storage
  userIdLS = localStorage.getItem('userId');
  userRoleIdLS = localStorage.getItem('userRoleId');

  constructor(
    private router: Router,
    private empresasService: EmpresasService,
    private logInService: LoginService,
    private cookie: CookieService
  ) {}

  ngOnInit(): void {
    if (this.userIdLS != null) {
      console.log(this.userIdLS);
    } else {
      // reedirigir a login
      this.router.navigate(['/login']);
    }
    this.getEmpresas();
  }

  getEmpresas = () => {
    this.empresasService.getEmpresasList().subscribe((response) => {
      this.empresas = [...response];
      this.empresasList = [...response];
      console.log('this.empresas :>> ', this.empresas);
    });
  };

  getIdEmpresas = (idEmpresa) => {
    if (idEmpresa !== null) {
      console.log('idEmpresa :>> ', idEmpresa);
      localStorage.setItem('idEmpresa', idEmpresa);
      this.router.navigate(['/documentos']);
    }
  };

  searchData = () => {
    $(document).ready(function () {
      $('#myInput').keyup(function () {
        const nthis = this;
        // Show only matching TR, hide rest of them
        $.each($('#myTable tbody tr'), function () {
          if (
            $(this)
              .text()
              .toUpperCase()
              .indexOf($(nthis).val().toUpperCase()) === -1
          ) {
            $(this).hide();
          } else {
            $(this).show();
          }
        });
      });
    });
  };

  logOut = () => {
    this.logInService.logout(this.userIdLS).subscribe((res) => {
      // localStorage.removeItem('userId');
      // localStorage.removeItem('userRoleId');
      // localStorage.removeItem('idEmpresa');
      // localStorage.removeItem('userToken');
      // localStorage.clear();
      console.log('res :>> ', res);
      if (res) {
        this.cookie.put('Bearer_auth', '');
        localStorage.setItem('username', '');
        localStorage.setItem('userId', '');
        localStorage.setItem('userRoleId', '');
        localStorage.setItem('idEmpresa', '');
        localStorage.setItem('userToken', 'false');
        this.router.navigate(['/login']);
      }

      if (res.Error === 'Please authenticate') {
        this.router.navigate(['/login']);
      }
    });
  };
}
